import React from 'react';
import styles from './Related.module.css';

export interface RelatedItem {
  section: string;
  slug: string;
  title: string;
  href: string;
  image?: string;
  score?: number;
}

interface RelatedProps {
  items?: RelatedItem[];
  heading?: string;
  /** Cap the number rendered (default: all provided). */
  limit?: number;
}

/**
 * A responsive grid of related-content cards. Fed by the TF-IDF output in each
 * page's related.json / the central related_index.json.
 */
// Our own absolute URLs → origin-relative (load from the current host); leave
// external URLs untouched.
const ownHostRelative = (u?: string): string =>
  (u || '').replace(/^https?:\/\/(www\.)?thedailydialectics\.com/i, '');

const Related: React.FC<RelatedProps> = ({ items = [], heading = 'Related', limit }) => {
  const list = limit ? items.slice(0, limit) : items;
  if (!list.length) return null;

  return (
    <section className={styles.related} aria-label={heading}>
      <h2 className={styles.heading}>{heading}</h2>
      <div className={styles.grid}>
        {list.map((item) => (
          <a key={`${item.section}/${item.slug}`} className={styles.card} href={ownHostRelative(item.href)}>
            <div className={styles.media}>
              {item.image ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img src={ownHostRelative(item.image)} alt={item.title} loading="lazy" decoding="async" />
              ) : (
                <div className={styles.fallback}>{item.section}</div>
              )}
            </div>
            <div className={styles.body}>
              <span className={styles.section}>{item.section.replace(/[-_]/g, ' ')}</span>
              <span className={styles.title}>{item.title}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Related;
